import React, {useCallback} from 'react';
import {prepareSameWindowUrlWithNavigateTo} from 'app/utilities/StringHelpers/StringHelpers';

const Tab = ({props, tab, index}) => {
  const {headerData: {tabIndex, tabs}, setTabIndex, context, isBusinessNavigation, isBusinessNavigationMode} = props;
  const handleOnClick = useCallback(() => {
    prepareSameWindowUrlWithNavigateTo(tab?.lobbyLink?.value, context);
    setTabIndex(index);
  }, [tab, context, setTabIndex, index]);

const getTabClass = (index) => {
  let selectedClass;
  let businessMode =  isBusinessNavigation || tabs[tabIndex]?.isBusinessTab?.value === true
  switch (businessMode) {
    case true:
      selectedClass = tabIndex === index ? 'tab-name-selected-business' : 'tab-name-private';
      break;
    case false:
      selectedClass = tabIndex === index ? 'tab-name-selected-private' : 'tab-name-business';
      break;
      default:
      selectedClass = tabIndex === index ? 'tab-name-selected-private' : 'tab-name-business';
  }
  return selectedClass;
};

  return (
    <span
      key={'tab' + index}
      className={getTabClass(index)}
      onClick={handleOnClick}
    >
      {tab?.name}
    </span>
  );
};

export default Tab;
